module.exports = __webpack_public_path__ + "img/gxlogo1.6e79912d.png";